import { render } from "./ProdStockBalanceComp.vue?vue&type=template&id=81a5123e&ts=true"
import script from "./ProdStockBalanceComp.vue?vue&type=script&lang=ts"
export * from "./ProdStockBalanceComp.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__